module.exports = __webpack_public_path__ + "static/media/Reporting.e0e10644.png";